import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import HomePage from "@/pages/HomePage";
import SolutionsPage from "@/pages/SolutionsPage";
import SystemsPage from "@/pages/SystemsPage";
import TechnicalSheetsPage from "@/pages/TechnicalSheetsPage";
import ProjectsPage from "@/pages/ProjectsPage";
import InstagramFeedPage from "@/pages/InstagramFeedPage";
import DistributorsPage from "@/pages/DistributorsPage";
import ContactPage from "@/pages/ContactPage";
import AdminLoginPage from "@/pages/AdminLoginPage";
import AdminDashboardPage from "@/pages/AdminDashboardPage";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import WhatsAppButton from "@/components/WhatsAppButton";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/admin/login" element={<AdminLoginPage />} />
          <Route path="/admin/*" element={<AdminDashboardPage />} />

          <Route
            path="*"
            element={
              <>
                <Navbar />

                <Routes>
                  <Route path="/" element={<HomePage />} />

                  {/* Redirect old indexed Google route */}
                  <Route path="/nosotros" element={<Navigate to="/" replace />} />

                  <Route path="/soluciones" element={<SolutionsPage />} />
                  <Route path="/soluciones/:slug" element={<SolutionsPage />} />
                  <Route path="/sistemas" element={<SystemsPage />} />
                  <Route path="/fichas-tecnicas" element={<TechnicalSheetsPage />} />
                  <Route path="/proyectos" element={<ProjectsPage />} />
                  <Route path="/instagram" element={<InstagramFeedPage />} />
                  <Route path="/blog" element={<Navigate to="/instagram" replace />} />
                  <Route path="/blog/:slug" element={<Navigate to="/instagram" replace />} />
                  <Route path="/distribuidores" element={<DistributorsPage />} />
                  <Route path="/contacto" element={<ContactPage />} />
                </Routes>

                <Footer />
                <WhatsAppButton />
              </>
            }
          />
        </Routes>

        <Toaster position="top-right" />
      </BrowserRouter>
    </div>
  );
}

export default App;